import moment from "moment";
import salesEvents from "../../shared/salesEvents";

export const $tokenManager = function($resourceManager, $f, $q, $rootScope, UserService) {

  // Namespace cached tokens per user so a previous session's `remaining` count
  // can't leak into a different user's session.
  const tokenKey = () => {
    const user = UserService.user;
    const id = user && (user.id || user.free_user_id);
    return `wt_current_token_${id}`;
  };

  const manager = {
    token: null,
    remaining: null,
    extra: 0,
    promise: null
  };

  const initialize = () => {
    // Set promise to return token from localStorage if it exists and not expired
    let token = localStorage.getItem(tokenKey());
    if (token) {
      token = JSON.parse(token);
      const expired = moment.unix(token.expiry).isBefore();
      if (token && !expired) {
        manager.promise = $q(resolve => resolve(setUpToken(token)));
      }
    }
  };

  const tokenRequest = () => {
    return $q((resolve, reject) => {
      $f.gen().then((fingerprint) => {
        $resourceManager
          .request('tokens', 'generate', {_f: fingerprint})
          .then(res => resolve(res))
          .catch(err => reject(err));
      });
    });
  };

  const setUpToken = response => {
    localStorage.setItem(tokenKey(), JSON.stringify(response));
    manager.token = response.token;
    manager.remaining = response.remaining;
    return manager.token;
  }

  const handleTokenError = error => {
    console.error(error);
    salesEvents.add('token', 'token::' + error.status, { error: error && error.data });
    $rootScope.$broadcast('token::' + error.status);
    return error;
  }

  const getToken = () => {
    return $q((resolve, reject) => {
      manager.token = null;
      localStorage.removeItem(tokenKey());
      tokenRequest()
        .then(res => resolve(setUpToken(res)))
        .catch(err => {
          manager.remaining = -1;
          manager.token = null;
          manager.promise = null;
          localStorage.removeItem(tokenKey());
          reject(handleTokenError(err));
        });
    })
  }

  manager.getToken = function ({forced} = {}) {

    // If forced, or we don't have a token, go get a new one
    if (forced || !manager.promise) {
      manager.promise = getToken();
    }

    // Return the promise for the new token
    return manager.promise;

  }

  initialize();

  return manager;
};

$tokenManager.$inject = ['$resourceManager', '$f', '$q', '$rootScope', 'UserService'];
